import api from "./api";
import { CadastroPayload } from "../resources/CadastroProvider";

export type StatusConsultaPresencaLink =
  | "USUARIO_MATRICULADO"
  | "USUARIO_NAO_MATRICULADO"
  | "USUARIO_NAO_CADASTRADO";

export type TipoPresencaLink = "PRESENTE" | "AUSENTE";

export interface ConsultaPresencaLinkResponse {
  success: boolean;
  data: {
    status: StatusConsultaPresencaLink;
    turma_id: number;
    usuario: {
      id: number;
      nome: string;
      cpf: string;
      email: string;
      ativo: boolean;
    } | null;
    inscricao: {
      id: number;
      turma_id: number;
      user_id: number;
      municipio_id: number | null;
      ambito_id: number | null;
      origem_inscricao: string;
      created_at: string;
    } | null;
    presencas: Array<{
      id: number;
      data_presenca: string;
      tipo: TipoPresencaLink;
      origem: string;
      created_at: string;
    }>;
  };
}

export interface DetalhePresencaLinkResponse {
  success: boolean;
  data: {
    link: {
      id: number;
      turma_id: number;
      codigo: string;
      ativo: boolean;
      created_by: number;
      canceled_at: string | null;
      canceled_by: number | null;
      created_at: string;
      updated_at: string;
    };
    acao: {
      id: number;
      tipologia_id: number;
      tipologia: string;
      modalidade_id: number;
      modalidade: string;
      nome: string;
      data_inicio: string;
      data_fim: string;
      observacoes: string | null;
    };
    turma: {
      id: number;
      acao_id: number;
      modalidade_id: number;
      modalidade: string;
      habilitar_cadastro?: number | boolean | null;
      habilitar_presenca_nao_inscrito?: number | boolean | null;
      nome: string;
      carga_horaria: number | null;
      data_inicio: string;
      data_fim: string;
      hora_inicio: string | null;
      hora_fim: string | null;
      link: string | null;
      endereco?: string | null;
      cep: string | null;
      logradouro: string | null;
      numero: string | null;
      complemento: string | null;
      bairro: string | null;
      cidade: string | null;
      uf: string | null;
      observacoes: string | null;
    };
  };
}

interface PresencaLinkPayload {
  cpf: string;
  latitude?: string;
  longitude?: string;
}

const getApiMessage = (error: any, fallback: string) => {
  return error?.response?.data?.message || (error instanceof Error ? error.message : fallback);
};

export async function consultarCpfPresencaLink(
  codigo: string,
  cpf: string,
): Promise<ConsultaPresencaLinkResponse> {
  try {
    const response = await api.post(`/presencas-link/${codigo}/consultar-cpf`, { cpf });
    return response.data;
  } catch (error: any) {
    throw new Error(getApiMessage(error, "Erro ao consultar CPF para presença."));
  }
}

export async function buscarDetalhePresencaLink(
  codigo: string,
): Promise<DetalhePresencaLinkResponse> {
  try {
    const response = await api.get(`/presencas-link/${codigo}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getApiMessage(error, "Erro ao consultar dados da turma."));
  }
}

export async function marcarPresencaLink(
  codigo: string,
  payload: PresencaLinkPayload,
): Promise<any> {
  try {
    const response = await api.post(`/presencas-link/${codigo}/marcar`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(getApiMessage(error, "Erro ao marcar presença."));
  }
}

export async function inscreverMarcarPresencaLink(
  codigo: string,
  payload: PresencaLinkPayload,
): Promise<any> {
  try {
    const response = await api.post(`/presencas-link/${codigo}/inscrever-marcar`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(getApiMessage(error, "Erro ao inscrever e marcar presença."));
  }
}

export async function cadastrarInscreverMarcarPresencaLink(
  codigo: string,
  payload: CadastroPayload & { latitude?: string; longitude?: string },
): Promise<any> {
  try {
    const response = await api.post(`/presencas-link/${codigo}/cadastrar-inscrever-marcar`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(getApiMessage(error, "Erro ao cadastrar, inscrever e marcar presença."));
  }
}
